import React from 'react';
import { useAuth } from '../auth/AuthContext';

interface NavigationProps {
  currentPage: string;
  onNavigate: (page: string) => void;
}

const Navigation: React.FC<NavigationProps> = ({ currentPage, onNavigate }) => {
  const { user, logout, hasRole } = useAuth();

  if (!user) return null;

  const menuItems = [
    { key: 'dashboard', label: 'Dashboard', icon: '🏠', roles: ['admin', 'manager', 'tenant'] },
    { key: 'reports', label: 'Reports', icon: '📊', roles: ['admin', 'manager'] },
    { key: 'requests', label: 'Request Management', icon: '📋', roles: ['admin', 'manager'] },
    { key: 'zones', label: 'BMS Zones', icon: '🗺️', roles: ['admin'] },
    { key: 'admin', label: 'Admin', icon: '⚙️', roles: ['admin'] },
  ];

  const visibleItems = menuItems.filter(item => 
    item.roles.some(role => hasRole(role as 'admin' | 'manager' | 'tenant'))
  );

  return (
    <div className="sidebar">
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--primary)' }}>
          BEP Dashboard
        </div>
        <div className="muted" style={{ fontSize: 12 }}>
          {user.role.charAt(0).toUpperCase() + user.role.slice(1)} • {user.username}
        </div>
      </div>

      <nav className="nav-section">
        {visibleItems.map(item => (
          <button
            key={item.key}
            onClick={() => onNavigate(item.key)}
            className={`nav-item ${currentPage === item.key ? 'active' : ''}`}
            style={{ border: 'none', background: 'transparent', font: 'inherit' }}
          >
            <div className="nav-row">
              <span style={{ marginRight: 8 }}>{item.icon}</span>
              <span className="grow">{item.label}</span>
            </div>
          </button>
        ))}
      </nav>

      <div style={{ marginTop: 'auto', paddingTop: 24 }}>
        <button
          onClick={logout}
          className="nav-item"
          style={{ border: 'none', background: 'transparent', font: 'inherit', color: 'var(--muted)' }}
        >
          <div className="nav-row">
            <span style={{ marginRight: 8 }}>🚪</span>
            <span className="grow">Sign Out</span>
          </div>
        </button>
      </div>
    </div>
  );
};

export default Navigation;